import { IonApp } from "@ionic/react";
import { useEffect } from "react";
import { SafeArea } from "capacitor-plugin-safe-area";
import { Loading } from "@/components/atoms/loading";
import { Content } from "@/components/content";
import { SplashScreen } from "@/lib/capacitor/splash-screen";
import { Compose } from "@/utils/components/compose";

export function StoreProvider(props: React.PropsWithChildren) {
  return <Compose providers={[<HydrationGate key="hydration" />]}>{props.children}</Compose>;
}

function HydrationGate(props: React.PropsWithChildren) {
  // const authHydrated = useStoreHydration(useAuthStore);
  // const preferencesHydrated = useStoreHydration(usePreferencesStore);

  // const isHydrated = authHydrated && preferencesHydrated;
  const isHydrated = true;

  useEffect(() => {
    (async function () {
      const safeAreaData = await SafeArea.getSafeAreaInsets();
      const { insets } = safeAreaData;
      for (const [key, value] of Object.entries(insets)) {
        document.documentElement.style.setProperty(`--safe-area-inset-${key}`, `${value}px`);
      }
    })();
  }, []);

  // useEffect(() => {
  //   if (Capacitor.getPlatform() === "android") {
  //     StatusBar.setOverlaysWebView({ overlay: true });
  //     StatusBar.setStyle({ style: Style.Light });
  //   }
  // }, []);

  if (!isHydrated) {
    SplashScreen.show();

    return (
      <IonApp>
        <Content
          withSafeAreaPadding
          className="part-scroll:items-center part-scroll:justify-center"
        >
          <Loading />
        </Content>
      </IonApp>
    );
  }

  SplashScreen.hide();

  return <>{props.children}</>;
}
